/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2024 ICEMEDX, Inc.
***********************************************/
import { IceEntity } from '../../core/IceEntity';

export class claimnote extends IceEntity {
  claim_note_key: string = "";
  note_reference_code: string = "";
  description: string = "";
  record_version: number = 0;
  offline_record_status: number = 0;

  constructor() {
    super();
  }

  gettablename(): string {
    return "CLAIM_NOTE";
  }
}

